import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import List from '@material-ui/core/List'

import { QCMenuItems } from "../../../src/routes";

import NavMenuItem from "../../components/common/NavItems/NavMenuItem";

const drawerWidth = 240;

const useStyles = makeStyles((theme) =>
    createStyles({
        appMenu: {
            width: "100%"
        },
        navList: {
            width: drawerWidth
        },
        menuItem: {
            width: drawerWidth
        },
        menuItemIcon: {
            color: "#00a650"
        }
    })
);


const QCMenu = () => {
    const classes = useStyles();

    return (
        <List component="nav" className={classes.appMenu} disablePadding>

            {QCMenuItems.map((item, index) => (
                <NavMenuItem {...item} key={index} />
            ))}

        </List>
    );

}

export default QCMenu;
